import React from "react";

import './squadflix-home-options.scss';
import {useNavigate} from "react-router-dom";

const SquadflixHomeOptions = () => {

    const navigate = useNavigate();

    return (
        <div className="squadflix-home-options">
            <button className="squadflix-home-options__option"
                    onClick={() => {
                        navigate('/squadflix/search-tmdb');
                    }}>
                Buscar <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            <button className="squadflix-home-options__option" onClick={() => navigate('/squadflix/live')}>
                En vivo <i className="fa-solid fa-tower-broadcast"></i>
            </button>
        </div>);
}

export default SquadflixHomeOptions;
